const MobileFacetLoading = () => {
  return <div className='h-7 w-22 animate-pulse rounded bg-gray-100 lg:hidden' data-sentry-component="MobileFacetLoading" data-sentry-source-file="mobile-facet-loading.tsx" />;
};
export default MobileFacetLoading;